import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl-next';
import { useShowNotice } from '@atlassian/proforma-utils/show-notice';
import { useSelectedFormStoreState } from '../store';
import { messages } from './messages';
import { clearAllFocus } from './utils';
export const useWithDiscardChangeNotice = () => {
  const {
    selectedFormStore
  } = useSelectedFormStoreState();
  const {
    showNotice
  } = useShowNotice();
  return useCallback((defaultHandler, confirmDiscardHandler, closeDiscardHandler) => {
    clearAllFocus();
    if (selectedFormStore !== null && selectedFormStore !== void 0 && selectedFormStore.answersModified) {
      showNotice({
        appearance: 'warning',
        title: /*#__PURE__*/React.createElement(FormattedMessage, messages.confirmCancelEditNoticeTitle),
        body: /*#__PURE__*/React.createElement(FormattedMessage, messages.confirmCancelEditNoticeBody),
        closeText: /*#__PURE__*/React.createElement(FormattedMessage, messages.confirmCancelEditNoticeCloseButton),
        confirmText: /*#__PURE__*/React.createElement(FormattedMessage, messages.confirmCancelEditNoticeConfirmButton),
        onConfirmHandler: confirmDiscardHandler || defaultHandler,
        onCloseHandler: closeDiscardHandler
      });
    } else {
      defaultHandler();
    }
  }, [selectedFormStore, showNotice]);
};